<template>
    <div>
        <b-modal
            id="otp-verification-popup"
            ref="modal"
            title="OTP Verification"
            size="sm"
            hide-footer
            no-close-on-backdrop
            :hide-header-close="loading"
            no-close-on-esc
            modal-class="hide-footer"
            @hidden="hideModal()"
            @shown="showModal()"
        >
            <b-form @submit.stop.prevent="onSubmit()" @reset="hideModal">
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="otp-input"
                            label="Enter OTP"
                            label-for="otp"
                        >
                            <b-form-input
                                id="otp-field"
                                v-model="formData.otp"
                                v-validate="{
                                    required: true,
                                    max: 6,
                                    min: 6,
                                    regex: /^([0-9]+)$/, //numbers only
                                }"
                                type="password"
                                placeholder="Enter the six-digit OTP"
                                data-vv-name="otp"
                                :class="{
                                    'is-invalid': errors.has('otp'),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <!-- <div class="col-md-12">
                        <b-form-group
                            id="new-password-input"
                            label="New Password"
                            label-for="new-password"
                        >
                            <b-form-input
                                id="new-password-field"
                                type="password"
                                v-model="formData.password"
                                placeholder="Create new password"
                                v-validate="{
                                    required: true,
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                :class="{
                                    'is-invalid': errors.has('new password'),
                                }"
                                name="new password"
                                ref="password"
                            ></b-form-input>
                            <div
                                class="system-user-warning password-validation"
                            >
                                <i
                                    class="icon-error_outline"
                                    v-b-tooltip.hover
                                    title=" 
                                    - Password must be between 6-20 characters.
                                    - Password must contain at least 1 uppercase letter, 1 lowercase. letter, 1 numeric character and at least 1 symbol.
                                    - The symbols allowed are !@#$%^&amp;*_=+      
                                    - Last 10 passwords cannot be reused."
                                ></i>
                            </div>
                        </b-form-group>
                    </div>

                    <div class="col-md-12">
                        <b-form-group
                            id="confirm-password-input"
                            label="Confirm Password"
                            label-for="confirm-password"
                        >
                            <b-form-input
                                id="confirm-password-field"
                                type="password"
                                v-model="formData.passwordConfirmation"
                                placeholder="Re-enter new password"
                                data-vv-name="password confirmation"
                                v-validate="{
                                    required: true,
                                    confirmed: 'password',
                                    max: 20,
                                    min: 6,
                                    regex: /^(?=^.{6,20}$)(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&amp;*_=+-])(?!.*\s).*$/,
                                }"
                                :class="{
                                    'is-invalid': errors.has(
                                        'password confirmation'
                                    ),
                                }"
                            ></b-form-input>
                        </b-form-group>
                    </div> -->
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        btn-label="Submit"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <!-- <base-button
                        btnLabel="Resend"
                        btnType="button"
                        btnVariant="link"
                        @click="resendOtp()"
                        :class="loading ? 'disabled' : ''"
                    ></base-button> -->
                    <a href="JavaScript:void(0);" @click="resendOtp()"
                        >Resend OTP</a
                    >
                </div>
            </b-form>
        </b-modal>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'

export default {
    // End of Component > data
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */

    props: {
        showModalProp: {
            type: Boolean,
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            formData: this.initializeFormData(),
        }
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        showModalProp(value) {
            if (value) {
                this.showModal()
            } else {
                this.hideModal()
            }
        },
        //hide Popup after success response
        hidePopup(value) {
            if (value) {
                this.hideModal()
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters([
            'loading',
            'hidePopup',
            'dataSegmentId',
            'customerRecord',
        ]),
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        showModal() {
            this.$refs.modal.show()
        }, // End of showModal() methods

        hideModal() {
            Object.assign(this.formData, this.initializeFormData())
            this.$emit('hide-modal')
            this.$refs.modal.hide()
            this.$validator.reset()
        }, // End of hideModal() methods

        initializeFormData() {
            return {
                otp: '',
                customerId: '',
                sendType: '',
            }
        }, // End of initializeFormData() methods

        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    //filling up data segment ID & Customer ID

                    this.formData.dataSegmentId = localStorage.getItem(
                        'activeDataSegmentId'
                    )

                    this.formData.customerId = this.$route.params.id

                    this.formData.sendType = 'V'

                    let resourceApi = new resource('customers/verify-otp/')

                    let { data } = await resourceApi.store(this.formData)
                    if (data) {
                        this.$store.commit('setRefreshProfile', true)
                        this.$store.commit('setSuccess', data.message)
                    }

                    // Clearing formData fields and close popup on success response
                    if (data) {
                        this.clearFormData()
                        this.$refs.modal.hide()
                    }
                } catch (error) {
                    //console.log(error, 'There is an error on submit OTP')
                    this.$store.commit('setError', error)
                }
            } else {
                let error = this.errors.all()[0]
                // if (!checkPassword && !error) {
                //     error =
                //         'The password must contain at least: 1 uppercase letter, 1 lowercase letter, 1 number, and one special character'
                // }
                this.$store.commit('setError', error)
            }
        }, // End of onSubmit() method

        async resendOtp() {
            try {
                //filling up data segment ID & Customer ID

                this.formData.dataSegmentId = localStorage.getItem(
                    'activeDataSegmentId'
                )

                this.formData.customerId = this.$route.params.id

                this.formData.sendType = 'R'

                let resourceApi = new resource('customers/verify-otp/')

                let { data } = await resourceApi.store(this.formData)
                if (data) {
                    this.$store.commit('setRefreshProfile', true)
                    this.$store.commit('setSuccess', data.message)
                }

                // Clearing formData fields and close popup on success response
                if (data) {
                    this.clearFormData()
                    this.$refs.modal.hide()
                }
            } catch (error) {
                //console.log(error, 'There is an error on resending OTP')
                this.$store.commit('setError', error)
            }
        },

        clearFormData() {
            this.$validator.reset()
            Object.assign(this.formData, this.initializeFormData())
        },
    }, // End of Component > methods
}
</script>
